export default __webpack_public_path__ + "static/media/free-lesson.1198e0f4.jpg";